import React from "react";
import GuidePanel from "../GuidePanel.js";
import {
  GuideLead,
  GuideCallout,
  GuideCard,
  GuideCardGrid,
} from "../GuideBlocks.js";

const MentalClarityAtWorkSection = ({ heading, accentIndex = 3 }) => (
  <GuidePanel sectionId="mental-clarity-at-work" heading={heading} accentIndex={accentIndex}>
    <GuideLead>Mental clarity improves every aspect of professional performance.</GuideLead>
    <p className="guide-panel__p">
      Most workplace friction is not caused by events — a short reply, a skipped meeting invite, a
      question in a review — but by the interpretations attached to them. Professionals who separate
      the two respond to what actually happened instead of the story about it, which means faster
      decisions, fewer defensive emails, and less time replaying conversations.
    </p>
    <GuideCardGrid columns={3}>
      <GuideCard iconKey="thinking" title="Prioritize effectively" />
      <GuideCard iconKey="thinking" title="Communicate clearly" />
      <GuideCard iconKey="thinking" title="Solve problems efficiently" />
      <GuideCard iconKey="thinking" title="Handle feedback constructively" />
      <GuideCard iconKey="thinking" title="Reduce unnecessary conflict" />
      <GuideCard iconKey="thinking" title="Build stronger relationships" />
    </GuideCardGrid>
    <GuideCallout variant="fuchsia">
      For introverts, mental clarity also improves confidence by helping translate thoughtful ideas into clear
      communication.
    </GuideCallout>
  </GuidePanel>
);

export default MentalClarityAtWorkSection;
